import { Select } from "antd";
import { FC } from "react";
import useUtil from "../../../hooks/useUtil";
import { IOption } from "../../../models/common.model";
import { useTranslation } from "react-i18next";

interface IProps {
  publisherCode?: string;
  setPublisherCode: (publisherCode: string) => void;
  disabled?: boolean;
};

const PublisherSelect: FC<IProps> = ({
  publisherCode,
  setPublisherCode,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { getDetailCodeOptions } = useUtil();
  const options = getDetailCodeOptions('SY0014');

  return (
    <Select
      className="w-150p"
      placeholder={t('common.button.select')}
      value={publisherCode}
      onChange={setPublisherCode}
      disabled={disabled}
    >
      {options?.map((option: IOption, index: number) => (
        <Select.Option
          key={index}
          value={option.value}
        >
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PublisherSelect;